import { render, staticRenderFns } from "./QuizCreateForm.vue?vue&type=template&id=c8bad3b0&"
import script from "./QuizCreateForm.vue?vue&type=script&lang=js&"
export * from "./QuizCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports